import React from 'react'

// core components
import AutoCompleteDropdown from 'components/CustomDropdown/AutoCompleteDropdown'

// Apollo thingy
import { graphql, Query } from 'react-apollo'

//wrapper specific, each dropdown needs a specific one
import { dictRoles } from '../../queries/getDataForDropdowns'

// props here holds the classes and pass it down
const namePlaceholder = props => (
  <Query query={dictRoles} variables={{ subType: props.subType }} errorPolicy="all">
    {({ loading, error, data }) => {
      // console.log(data)
      if (error) return `<p>${error}</p>`
      if (loading) {
        return <p>Loading...</p>
      } else {
        const { helperText = 'Roles ...', labelText = '', ...rest } = props
        return (
          <AutoCompleteDropdown
            options={data.roles.map(d => ({
              value: d.id,
              label: d.name
            }))}
            placeholder={helperText}
            labelText={labelText}
            {...rest}
          />
        )
      }
    }}
  </Query>
)

export default graphql(dictRoles)(namePlaceholder)
